/**
 * tdesign v0.48.5
 * (c) 2022 tdesign
 * @license MIT
 */

import VueCompositionAPI from '@vue/composition-api';
import _Upload from './upload.js';
import { withInstall } from '../utils/withInstall.js';
import './style/css.js';
import './interface.js';
import '../_chunks/dep-9d6f3de6.js';
import '@babel/runtime/helpers/defineProperty';
import 'tdesign-icons-vue';
import './props.js';
import './themes/normal-file.js';
import '../loading/index.js';
import '../loading/loading.js';
import '../loading/icon/gradient.js';
import '../_common/js/loading/circle-adapter.js';
import '../_common/js/utils/set-style.js';
import '../_common/js/utils/helper.js';
import '@babel/runtime/helpers/toConsumableArray';
import '@babel/runtime/helpers/objectWithoutProperties';
import '@babel/runtime/helpers/slicedToArray';
import '../config-provider/config-receiver.js';
import 'vue';
import 'lodash/mergeWith';
import '../config-provider/context.js';
import 'lodash/merge';
import '../_common/js/global-config/default-config.js';
import '../_common/js/global-config/locale/zh_CN.js';
import '../config-provider/type.js';
import '../utils/mixins.js';
import '../utils/dom.js';
import 'raf';
import 'lodash/isString';
import '../utils/easing.js';
import '../utils/render-tnode.js';
import '@babel/runtime/helpers/typeof';
import 'lodash/camelCase';
import 'lodash/kebabCase';
import '../utils/transfer-dom.js';
import '../loading/props.js';
import '../loading/type.js';
import '../loading/plugin.js';
import '../config.js';
import 'lodash/capitalize';
import '../link/index.js';
import '../link/link.js';
import '../link/props.js';
import '../link/type.js';
import '../_common/js/upload/utils.js';
import '../_common/js/log/log.js';
import '../hooks/useGlobalIcon.js';
import '../hooks/useConfig.js';
import '../config-provider/useConfig.js';
import './constants.js';
import './themes/dragger-file.js';
import '../button/index.js';
import '../button/button.js';
import '../button/props.js';
import '../utils/ripple.js';
import '../button/type.js';
import '../hooks/useCommonClassName.js';
import './hooks/useDrag.js';
import '../image-viewer/index.js';
import '../image-viewer/image-viewer.js';
import '../image-viewer/props.js';
import '../image-viewer/base/Container.js';
import '../image-viewer/base/ImageModalIcon.js';
import '../hooks/tnode.js';
import 'lodash/isEmpty';
import 'lodash/isFunction';
import '../hooks/render-tnode.js';
import 'lodash/isObject';
import '../image-viewer/base/ImageViewerUtils.js';
import '../tooltip/index.js';
import '../tooltip/tooltip.js';
import '../tooltip/props.js';
import '../popup/props.js';
import '../popup/popup.js';
import '@popperjs/core';
import '../utils/helper.js';
import '../popup/container.js';
import '../utils/map-props.js';
import '../tooltip/type.js';
import '../image-viewer/utils.js';
import '../image-viewer/base/ImageItem.js';
import '../image-viewer/hooks.js';
import '../image-viewer/base/ImageViewerModal.js';
import '../dialog/index.js';
import '../dialog/dialog.js';
import 'lodash/isNumber';
import 'lodash/throttle';
import '../dialog/actions.js';
import '../dialog/props.js';
import '../utils/event.js';
import '../hooks/useDestroyOnClose.js';
import '../dialog/stack.js';
import '../dialog/type.js';
import '../dialog/plugin.js';
import '../hooks/useVModel.js';
import '../hooks/useDefaultValue.js';
import '../image-viewer/const.js';
import '../image-viewer/type.js';
import './themes/image-card.js';
import './themes/multiple-flow-list.js';
import '../_chunks/dep-eb8a4de6.js';
import './hooks/useUpload.js';
import '../_common/js/upload/main.js';
import '@babel/runtime/helpers/toArray';
import '../_common/js/upload/xhr.js';
import './themes/custom-file.js';

var Upload = withInstall(_Upload, VueCompositionAPI);

export { Upload, Upload as default };
//# sourceMappingURL=index.js.map
